<template>
  <v-chip
    :color="color"
    outlined
    class="v-chip-light-bg"
    small
  >
    <v-icon left>
      {{ icon }}
    </v-icon>
    {{ text }}
  </v-chip>
</template>

<script>
import { ref, computed } from '@vue/composition-api'
import {
  mdiHelpCircleOutline,
} from '@mdi/js'

export default {
  props: {
    status: {
      type: Number,
      required: true,
    },
    statuses: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const statuses = ref(props.statuses)
    const GetById = id => statuses.value.find(item => item.id === id)

    const text = ref('')
    const color = ref('#9E9E9E')
    const icon = computed(() => {
      const currentStatus = GetById(props.status)
      if (currentStatus != null) {
        text.value = currentStatus.text
        color.value = currentStatus.color

        return currentStatus.icon
      }

      text.value = 'Desc.'
      color.value = '#9E9E9E'

      return mdiHelpCircleOutline
    })

    return {
      icon,
      text,
      color,
    }
  },
}
</script>
